export default {
  namespaced: true,
  state: {
    ball: null, 
    world: null,
    tracking: null,
    light: null,
    travelling: null,
    use_tween: false
  },
  mutations: {
    'SET_ASSET' (state, data) {
      state[data.name] = data.obj
    },
    'USE_TWEEN' (state, bol) {
      state.use_tween = bol
    }
  },
  getters: {
    ball: state => state.ball,    
    world: state => state.world,    
    tracking: state => state.tracking,    
    use_tween: state => state.use_tween,    
    light: state => state.light,    
    travelling: state => state.travelling,    
  }
}
